import React from "react";

// Style
import { Svg } from "./styles";

const Rectangle = ({ size = 60 }) => {
  // <path d="M24 0h-24v24h24v-24z" />
  // <path d="M24 24h-24v-24h24v24zm-22-22v20h20v-20h-20z" /> border
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 22 22`}
    >
      <path d="M22 0h-22v22h22v-22z" />
    </Svg>
  );
};

export default Rectangle;
